var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBtn),expression:"showBtn"}],staticClass:"special-coupon-btn-wrap",class:{
      'custom-transition': _vm.isTouchEnd,
    },style:({
      left: `${_vm.btnPoint.x}px`,
      top: `${_vm.btnPoint.y}px`,
      transform: `translate(${_vm.transform.x}px, ${_vm.transform.y}px)`,
    }),on:{"touchstart":_vm.touchStart,"touchmove":_vm.touchMove,"touchend":_vm.touchEnd,"click":_vm.toSpecialCouponPage}},[_c('img',{staticClass:"special-coupon-btn",attrs:{"src":require("@/assets/img/chargingVoucher/special-coupon-img.png")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }